import { Component, Input } from '@angular/core';
import { AppConst } from '@app/App.const';
import { Subject, takeUntil } from 'rxjs';
import { MenuItem } from '@app/shared/common/models/menu-item.model';
import { NavigationService } from '@app/shared/common/navigation/navigation.service';
import { SettingsService } from '@app/shared/common/services/Authentication/settings.service';
import { ModuleLevelPermissionService } from '@app/shared/common/services/Permission/module-level-permission.service';
import { BulkDownloadService } from '@app/shared/common/services/bulk-download/bulk-download.service';
import { CommonMethodsService } from '@app/shared/common/services/common-methods.service';
import { SignalRConnectionService } from '@app/shared/common/services/signal-r-connection.service';
import { groupTypes } from '@app/shared/common/utils/app-enum';
import { notificationJSON, VerticalNavigationConfig,VerticalNavigationMenuList } from '@app/shared/common/utils/app-interface';
import { getTargetRegion, removeSpace } from '@app/shared/common/utils/app-utils';
// import { VerticalNavigationMenuItemModel } from '@ey-xd/ng-motif';
// import { 
//   VerticalNavigationMenuList,
// } from '@ey-xd/ng-motif';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone:false
})
export class HeaderComponent {
  config: VerticalNavigationConfig = {
    position: 'fixed',
    offset: {
      top: 62,
    },
    width: {
      default: 54,
      expanded: 305,
    },
    height: 'calc(100vh - 57px)',
  };
  public expanded = false;
  public readonly instanceName =
    getTargetRegion() === 'global' ? 'Global' : getTargetRegion().toUpperCase();

  //Append/remove new options here
  // public menuOptionsCopy: VerticalNavigationMenuList = [
  //   new MenuItem(
  //     'Fund Listing',
  //     '/assets/icons/action/ic_dashboard_24px.svg',
  //     'internal',
  //     '/dt-dashboard'
  //   ),
  //   new MenuItem(
  //     'Create Fund Request',
  //     '/assets/images/upload-square.svg',
  //     'internal',
  //     '/dashboard/create-fund-request'
  //   ),
  //   new MenuItem(
  //     'Live Mapping',
  //     '/assets/images/account_tree.svg',
  //     'internal',
  //     '/custom-mapping'
  //   ),
  //   new MenuItem(
  //     'Templates',
  //     '/assets/images/template_icon.svg',
  //     'internal',
  //     '/templates'
  //   ),
  //   // new MenuItem(
  //   //   'Administration',
  //   //   '/assets/images/fr_assignment_icon.svg',
  //   //   'internal',
  //   //   'administration/fr'
  //   // ),
  //   new MenuItem(
  //     'Auditor Dashboard',
  //     '/assets/icons/action/ic_dashboard_24px.svg',
  //     'internal',
  //     '/auditor-dashboard'
  //   ),
  //   new MenuItem(
  //     'Configuration',
  //     '/assets/images/configuration_icon.svg',
  //     'internal',
  //     '/configuration'
  //   ),
  //   new MenuItem(
  //     'User Access Management',
  //     '/assets/images/uam_icon.svg',
  //     'internal',
  //     'user-access-management'
  //   ),

  menuOptionsCopy = [
    {
      label: 'Home',
      icon:'assets/icons/action/ic_home_24px.svg',
      exact: true,
      routerLink: ['/home']
    },
    {
      label: 'Fund Listing',
      icon:'assets/icons/action/ic_dashboard_24px.svg',
      exact: true,
      routerLink: ['/dt-dashboard']
    },
    {
      label:  'Create Fund Request',
      icon:'assets/images/upload-square.svg',
      exact: true,
      routerLink: ['/dashboard/create-fund-request']
    },
    {
      label: "Live Mapping",
      icon:'assets/images/account_tree.svg',     
      exact: true,
      routerLink: ['/custom-mapping']
    },
    {
      label: 'Templates',
      icon:'assets/images/template_icon.svg',
      exact: true,
      routerLink: ['/templates']
    },
    // {
    //   label: 'Administration',
    //   icon:'./assets/images/fr_assignment_icon.svg',
    //   exact: true,
    //   routerLink: ['administration/fr']
    // },
    {
      label: 'Auditor Dashboard',
      icon:'./assets/icons/action/ic_dashboard_24px.svg',
      exact:true,
      routerLink: ['/auditor-dashboard']
    },
    {
      label: 'Configuration',
      icon: './assets/images/configuration_icon.svg',
      exact:true,
      routerLink: ['/configuration']
    },
    {
      label: 'User Access Management',  
      icon:'./assets/images/uam_icon.svg',
      exact:true,
      routerLink: ['/user-access-management']
    },
    // {
    //   label: 'Self Onboarding',
    //   icon:'./assets/images/self_onboarding.svg',
    //   exact:true,
    //   routerLink: ['/self-onboarding']
    // }
  ];

  public menuOptions: any = [];

  public showUserDetail = false;
  public showMenu = false;
  public showModal = false;
  public notificationCount: number = 0;
  public newNotifications: notificationJSON[] = [];
  public isAccordionExpanded: boolean = false;
  public showBulkDownloadModal = false;
  private readonly destroy$ = new Subject<void>();
  @Input() public user={name:'',email:''}

  constructor(
    public signalRService: SignalRConnectionService,
    private SignalRConnectionService: SignalRConnectionService,
    private navigation: NavigationService,
    private settingsService: SettingsService,
    private permissionService: ModuleLevelPermissionService,
    private commonService: CommonMethodsService,
    public bulkDownloadService:BulkDownloadService
  ) {
    this.SignalRConnectionService.unreadNotificationCount?.subscribe(
      (notificationCount: number) => {
        this.notificationCount = notificationCount;
      }
    );

    this.SignalRConnectionService.newNotification?.subscribe(
      (notification: notificationJSON | null) => {
        if (notification) {
          // for future reference // this.SignalRConnectionService.refreshNotifications();
          this._addNotification(notification);
        }
      }
    );
  }

  ngOnInit() {
    // this.signalRService.buildSignalRConnection();
    this.permissionService.moduleLevelPermisssionDetails$
    .pipe(takeUntil(this.destroy$))
    .subscribe(res => {
      this.filterSideNavEntries(res);
    });

    // get user details call from common service
    this.settingsService.setUserName(this.user?.name && this.user.name.split(' ')[0])
    // for future reference //signalRService.totalNotificationCount
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  public filterSideNavEntries(permissions: any) {
    const menuOptionsList: any = [];
    (this.menuOptionsCopy as any).forEach(
      (menuOption: any) => {
        if (
          permissions?.some((obj: any) => obj.moduleName === menuOption.label)
        ) {
          menuOptionsList.push(menuOption);
        }
      }
    );
    this.menuOptions = menuOptionsList;
  }

  public toggleSidebar(value: boolean) {
    this.expanded = !value;
  }

  public _addNotification(notification: notificationJSON) {
    this.newNotifications.push(notification);
    // for future reference // this.SignalRConnectionService.getAllNotifications();
    this.SignalRConnectionService.appendNotification(notification);
    if (notification) {
      setTimeout(() => {
        if (!notification.isExpanded) {
          this.close(notification);
        }
      }, AppConst.notificationTimeOut);
    }
  }

  public close(notification: notificationJSON) {
    this.newNotifications = this.newNotifications.filter(
      (notif: notificationJSON) =>
        notif.notificationActionId !== notification.notificationActionId
    );
  }

  public addNotificationTemp() {
    this.SignalRConnectionService.addNotificationTemp();
  }

  public navigateToFundDetails(notification: notificationJSON) {
    if (notification.isExpanded) {
      this.navigation.navigateWithQueryParam(
        this.navigation.getAuditorFundDetails(
          notification.fundRequestId,
          notification.fundName,
          notification.administrator,
          notification.aggConsoleFlag
        ),
        { isParent: notification.isParent }
      );
      this.close(notification);
    }
  }

  public toggleNotificationPopUp(notification: notificationJSON, event: any) {
    notification.isExpanded = !notification.isExpanded;
    event.stopPropagation();
  }

  public get groupTypes() {
    return groupTypes;
  }

  public removeSpace(inp: string) {
    return removeSpace(inp);
  }

  public logout() {
    this.settingsService.logoff();
  }
}
